<template>
    <div class="user-wrapper" :class="{ blur: isQrcodeOpen }" v-if="token">
        <div
            class="qrcode-yyq"
            :class="{ active: isQrcodeOpen }"
            @click="closeQrcode"
        >
            <div class="qrcode-container" @click.stop>
                <div class="user">
                    <img
                        :src="
                            ossResolvedAvatar ||
                            (yyq_type === 1
                                ? defaultUser.tuohuAvatar
                                : yyq_type === 2
                                ? defaultUser.fuwuAvatar
                                : defaultUser.touristGuideAvatar)
                        "
                        alt="avatar"
                    />
                    <span
                        class="name"
                        v-text="userInfo.nick_name || defaultUser.name"
                    ></span>
                </div>
                <qrcode
                    :value="codeStr"
                    class="qr-user"
                    :options="{ size: qrcodeSize }"
                    tag="img"
                ></qrcode>
                <p class="h">长按图片/截图保存到相册</p>
                <img
                    :src="qrcodeCloseSrc"
                    alt="close-btn"
                    class="close"
                    @click="closeQrcode"
                />
            </div>
        </div>
        <div
            class="avatar-wrapper-tuo"
            v-if="yyq_type != 1 && yyq_type != 2 && userInfo.type != 10"
        >
            <div class="avatar-container">
                <img
                    :src="ossResolvedAvatar || defaultUser.avatar"
                    alt="avatar"
                    class="avatar"
                />
                <img
                    :src="takePhotoIconSrc"
                    class="change-icon"
                    @click="chooseImage"
                    v-if="userInfo.type > 0"
                />
            </div>
            <div class="name-wrapper">
                <span
                    class="name"
                    v-text="userInfo.nick_name || defaultUser.name"
                ></span>
                <span
                    class="name"
                    v-if="userInfo.account"
                    v-text="userInfo.account"
                ></span>
            </div>
        </div>
        <div class="yyq-user-wrapper" v-if="yyq_type">
            <img
                :src="
                    ossResolvedAvatar ||
                    (yyq_type === 1
                        ? defaultUser.tuohuAvatar
                        : yyq_type === 2
                        ? defaultUser.fuwuAvatar
                        : defaultUser.touristGuideAvatar)
                "
                alt="avatar"
                class="left"
            />
            <div class="right">
                <div
                    class="yyq_name"
                    v-text="userInfo.nick_name || defaultUser.name"
                ></div>
                <div class="yyq_account">
                    <span>账号：{{ userInfo.account || "" }}</span>
                    <span
                        class="qr-line"
                        v-if="yyq_type === 2"
                        @click="openQrcode"
                        ><img
                            class="qr-icon"
                            src="https://oss.tuoxingwang.com/vaporetto-assets/yyq/my/qrcode.png"
                            alt="qrcode-icon" /><img
                            src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/right-icon.svg"
                            class="right-icon"
                    /></span>
                </div>
            </div>
        </div>
        <div
            class="order-wrapper-tuo"
            :class="{ orderActive: userInfo.type === 10 }"
            v-if="yyq_type != 1 && yyq_type != 2"
        >
            <nav class="account-nav">
                <div class="each-nav-item" @click="redirectToOrder(0)">
                    <img :src="order1Src" alt="order1-icon" />
                    <span>全部</span>
                </div>
                <div class="each-nav-item" @click="redirectToOrder(1)">
                    <img :src="order2Src" alt="order2-icon" />
                    <span>待支付</span>
                </div>
                <div class="each-nav-item" @click="redirectToOrder(2)">
                    <img :src="order3Src" alt="order3-icon" />
                    <span>待使用</span>
                </div>
                <div class="each-nav-item" @click="redirectToOrder(3)">
                    <img :src="order4Src" alt="order4-icon" />
                    <span>已完成</span>
                </div>
                <div class="each-nav-item" @click="redirectToOrder(4)">
                    <img :src="order5Src" alt="order5-icon" />
                    <span>退款</span>
                </div>
            </nav>
        </div>
        <div class="card-wrapper" v-if="yyq_type">
            <div class="user-card" v-if="yyq_type">
                <div class="b1">
                    <p class="user-money">
                        <span class="suffix">￥</span
                        >{{ settleMoney.already || 0 }}
                    </p>
                    <p class="hint">已结算</p>
                </div>
                <div class="b2">
                    <span>待结算</span>
                    <span>￥ {{ settleMoney.future || 0 }}</span>
                </div>
            </div>
        </div>
        <div
            class="list-wrapper-tuo iphonex-adapt-padding"
            :class="{ normal: userInfo.type }"
        >
            <template>
                <div
                    class="each-list"
                    v-if="userInfo.type == 1"
                    @click="toCommission"
                >
                    <img :src="userMoneySrc" class="each-icon" />
                    <span>我的佣金</span>
                    <img :src="rightIconSrc" class="right-icon" />
                </div>
                <div
                    class="each-list"
                    v-if="userInfo.type == 1"
                    @click="openQrcode"
                >
                    <img :src="userQrcodeSrc" class="each-icon" />
                    <span>我的推广码</span>
                    <img :src="rightIconSrc" class="right-icon" />
                </div>
                <!-- <div class="each-list"
                    @click="redirectToSum"
                   v-if="yyq_type===1||yyq_type===2||userInfo.type===10">
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/list-2.svg"
                        class="each-icon">
                    <span>结算记录</span>
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/right-icon.svg"
                        class="right-icon">
                </div> -->
                <!-- <div class="each-list"
                    @click="redirectToOrderDetail"
                    v-if="yyq_type===1||yyq_type===2">
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/list-1.svg"
                        class="each-icon">
                    <span>订单明细</span>
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/right-icon.svg"
                        class="right-icon">
                </div> -->
                <!-- <div class="each-list" v-if="!yyq_type"
                    @click="toAddress" style="border-bottom: 1px solid #e6e6e6;">
                    <img :src="myAddressSrc" class="each-icon">
                    <span>我的收货地址</span>
                    <img :src="rightIconSrc" class="right-icon">
                </div>
                <div class="each-list" @click="toChangePassword" v-if="userInfo.type == 4 || userInfo.type == 1">
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/png/change-password.png" class="each-icon">
                    <span>修改密码</span>
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/user/svg/right-icon.svg" class="right-icon">
                </div> -->
                <div class="each-list">
                    <img :src="myTelSrc" class="each-icon" />
                    <span>平台热线</span>
                    <a
                        class="tel"
                        :href="`tel:${hotLine}`"
                        v-text="hotLine"
                    ></a>
                </div>
            </template>
            <div class="each-list exit" @click="exit" v-if="canExit">
                <span class="exit">退出登录</span>
            </div>
        </div>
        <div class="empty" v-if="navScene"></div>
        <boms-footer v-if="!yyq_type" :active="2"></boms-footer>
    </div>
</template>

<script>
import { _auth } from "@/js/auth";
import VueQrcode from "@xkeshi/vue-qrcode";
export default {
    name: "User",
    components: {
        qrcode: VueQrcode,
    },
    props: {},
    data() {
        return {
            defaultUser: {
                avatar: API.ossUrl + "common/empty_icons/noimage-1-1-2.png",
                name: "未知用户",
                tuohuAvatar: API.ossUrl + "yyq/my/user_tuohu.png",
                fuwuAvatar: API.ossUrl + "yyq/my/user_fuwu.png",
                touristGuideAvatar:
                    API.ossUrl + "yyq/my/user_tourist_guide.png",
            },
            toastInst: null,
            hotLine: "0931-8455399-803",
            userInfo: {},
            // 用户type： 0：普通游客 1：推广员  2：供应商  3：批发商  4：分销商  5：内部员工  6：普通管理员  7：超级管理员',
            qrcodeSize: window.innerWidth * 0.648,
            isQrcodeOpen: false,
            codeStr: "",
            settleMoney: {},
            qrcodeCloseSrc: "",
            takePhotoIconSrc: "",
            order1Src: "",
            order2Src: "",
            order3Src: "",
            order4Src: "",
            order5Src: "",
            userMoneySrc: "",
            rightIconSrc: "",
            userQrcodeSrc: "",
            myAddressSrc: "",
            myTelSrc: "",
            yyq_type: "",
            token: sessionStorage.getItem("token") || "",
        };
    },
    computed: {
        ossResolvedAvatar() {
            if (
                !this.userInfo.profile_picture ||
                this.userInfo.profile_picture === "0"
            )
                return "";
            return (
                `${this.userInfo.profile_picture}?x-oss-process=image/resize,h_300` ||
                ""
            );
        },
        canExit() {
            // 批发商 分销商 推广员 驼户 服务人员 导游 可以退出登录
            if (!this.userInfo.type) return false;
            return [1, 3, 4, 8, 9, 10].some(
                (type) => type == this.userInfo.type
            );
        },
    },
    watch: {
        $route(to) {
            if (to.query.mdl) {
                document.title = "我的";
            } else {
                if (this.isQrcodeOpen) {
                    this.closeQrcode("using_back_button");
                    this.getSettlePrice();
                }
            }
        },
    },
    created() {
        this.navScene = navigator.appVersion.match(/iphone/gi);
        if (this.token) {
            this.getUserInformation();
        } else {
            _auth(this, () => {
                this.getUserInformation();
            });
        }
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
    },
    mounted() {
        this.qrcodeCloseSrc = API.ossUrl + "yyq/my/qrcode-close.png";
        this.takePhotoIconSrc = API.ossUrl + "user/svg/take-photo-icon.svg";
        this.order1Src = API.ossUrl + "yyq/my/order1.png";
        this.order2Src = API.ossUrl + "yyq/my/order2.png";
        this.order3Src = API.ossUrl + "yyq/my/order3.png";
        this.order4Src = API.ossUrl + "yyq/my/order4.png";
        this.order5Src = API.ossUrl + "yyq/my/order5.png";
        this.userMoneySrc = API.ossUrl + "user/png/user-money.png";
        this.rightIconSrc = API.ossUrl + "user/svg/right-icon.svg";
        this.userQrcodeSrc = API.ossUrl + "user/png/user-qrcode.png";
        this.myAddressSrc = API.ossUrl + "user/png/my-address.png";
        this.myTelSrc = API.ossUrl + "user/png/my-tel.png";
    },
    destroyed() {},
    methods: {
        getUserInformation() {
            let { user_info } = sessionStorage;
            if (user_info) {
                this.userInfo = JSON.parse(user_info);
                this.yyq_type = this.get_yyq_type();
                if (this.userInfo.type == 1) {
                    this.getQrcode();
                }
                if (this.userInfo.type >= 8 && this.userInfo.type <= 10) {
                    this.getSettlePrice();
                }
            }
        },
        exit() {
            this.$confirm({
                content: "确定要退出吗？",
                yesText: "确定",
                noText: "取消",
            })
                .then(() => {
                    let fromHomeTemp = sessionStorage.getItem("fromHome");
                    sessionStorage.clear();
                    sessionStorage.fromHome = fromHomeTemp;
                    localStorage.is_logout_sp = 1;
                    this.$router.push({
                        name: "login",
                    });
                })
                .catch((e) => console.log(e));
        },
        get_yyq_type() {
            //1,2,3分别对应type的8,9,10 1驼户，2服务人员,3导游
            let val = 0;
            switch (Number(this.userInfo.type)) {
                case 8:
                    val = 1;
                    break;
                case 9:
                    val = 2;
                    break;
                case 10:
                    val = 3;
                    break;
                default:
                    val = 0;
                    break;
            }
            return val;
        },
        chooseImage() {
            let vm = this;
            if (ua === "wx") {
                wx.chooseImage({
                    count: 1,
                    sizeType: ["compressed"],
                    success: function (res) {
                        wx.uploadImage({
                            localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
                            isShowProgressTips: 1, // 默认为1，显示进度提示
                            success: function (result) {
                                vm.uploadAvatar(result.serverId, "wx"); // 返回图片的服务器端ID
                            },
                            fail: function () {
                                vm.$alert("上传头像失败！");
                            },
                        });
                    },
                });
            } else {
                AlipayJSBridge.call(
                    "chooseImage",
                    {
                        count: 1,
                    },
                    function ({ apFilePathsV2, apFilePaths, errorCode }) {
                        if (errorCode) {
                            vm.$alert("上传头像失败！");
                            return;
                        }
                        let apFilePath = apFilePathsV2 || apFilePaths || [];
                        if (typeof apFilePath === "string") {
                            try {
                                apFilePath = JSON.parse(apFilePath);
                            } catch (e) {}
                        }
                        vm.getLocalImageBase64(apFilePath)
                            .then((url) => vm.uploadAvatar(url, "ali"))
                            .catch((e1) => console.log(e1));
                    }
                );
            }
        },
        uploadAvatar(img, type) {
            this.toastInst = this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "上传中...",
            });
            this.$axios
                .post(
                    `${window.API.user.uploadAvatar}?token=${sessionStorage.token}`,
                    { img, type }
                )
                .then(({ data }) => {
                    this.toastInst.clear();
                    if (data.code == 200) {
                        this.$toast("修改头像成功！");
                        this.$set(
                            this.userInfo,
                            "profile_picture",
                            data.data[0]
                        );
                        if (sessionStorage.user_info) {
                            let tmp_info = JSON.parse(sessionStorage.user_info);
                            tmp_info.profile_picture = data.data[0];
                            sessionStorage.user_info = JSON.stringify(tmp_info);
                        }
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.toastInst.clear();
                });
        },
        getLocalImageBase64(apFilePath) {
            return new Promise((resolve, reject) => {
                var image = new Image();
                image.crossOrigin = "anonymous";
                image.onload = function () {
                    var canvas = document.createElement("CANVAS");
                    var context = canvas.getContext("2d");
                    canvas.height = image.height;
                    canvas.width = image.width;
                    context.drawImage(image, 0, 0);
                    try {
                        var dataURL = canvas.toDataURL("image/jpeg");
                        resolve(dataURL);
                    } catch (error) {
                        reject(error);
                    }
                    canvas = null;
                };
                image.src = apFilePath[0];
            });
        },
        getQrcode() {
            this.$axios
                .get(
                    `${window.API.user.getQrcode}?token=${sessionStorage.token}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.codeStr = data.data[0];
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        getSettlePrice() {
            //获取结算金额
            this.$axios
                .get(
                    `${window.API.user.camelinfo}?token=${sessionStorage.token}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.settleMoney = data.data;
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        toAddress() {
            this.$router.push({ name: "userAddress" });
        },
        toCommission() {
            this.$router.push({ name: "userCommission" });
        },
        toQRCode() {
            this.$router.push({ name: "userQRCode" });
        },
        toCoupon() {
            //type:1有效优惠券2无效优惠券
            this.$router.push({ name: "userCoupon", params: { type: 1 } });
        },
        redirectToOrder(index) {
            this.$router.push({ name: "userOrderList", query: { index } });
        },
        redirectToSum() {
            this.$router.push({ name: "userYYQSettlementRecord" });
        },
        redirectToOrderDetail() {
            this.$router.push({ name: "userYYQOrderDetail" });
            sessionStorage.yyq_user_type = this.yyq_type;
        },
        closeQrcode(mode) {
            this.isQrcodeOpen = false;
            if (typeof mode === "object") {
                this.$router.go(-1);
                this.getSettlePrice();
            }
        },
        openQrcode() {
            const fullPath = this.$route.fullPath;
            const query = fullPath.indexOf("?") === -1 ? "?mdl=1" : "&mdl=1";
            this.$router.push(`${fullPath}${query}`);
            this.isQrcodeOpen = true;
        },
        toChangePassword() {
            this.$router.push({ name: "changePassword" });
        },
    },
};
</script>
<style scoped lang="scss">
// .outer-wrapper-white{
//     // background: #f5f5f5;
//     height: 100%;
// }
// .outer-wrapper-gray{
//     background: #f5f5f5;
//     height: 100%;
// }
.user-wrapper {
    // background: #f5f5f5;
    height: 100%;
    padding-bottom: 2.666666rem;
    overflow-y: scroll;
    &.blur > div:not(:first-child) {
        // filter: blur(3px);
        transition: all 0.3s;
    }
    &.blur > footer {
        // filter: blur(3px);
        transition: all 0.3s;
    }
    .qrcode-yyq {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        transition: 0.3s;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: -1;
        opacity: 0;
        &.active {
            z-index: 10000;
            opacity: 1;
            .qrcode-container {
                transform: scale(1);
            }
        }
        .qrcode-container {
            width: 8.08rem;
            height: 11.066667rem;
            background: $white;
            transition: 0.3s;
            border-radius: 0.266667rem;
            padding: 0.533333rem;
            position: relative;
            text-align: center;
            transform-origin: 100% -15%;
            transform: scale(0);
            .close {
                position: absolute;
                right: 0.533333rem;
                top: 0.533333rem;
                width: 0.373333rem;
                height: 0.373333rem;
            }
            .user {
                position: absolute;
                left: 2.9rem;
                top: -1.066667rem;
                margin-bottom: 0.586667rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: left;
                img {
                    width: 2.133333rem;
                    height: 2.133333rem;
                    border-radius: 50%;
                }
                .name {
                    margin-top: 0.293333rem;
                    font-size: 16px;
                    color: #444;
                    font-weight: bold;
                }
                .sub-name {
                    margin-top: 0.293333rem;
                    font-size: 14px;
                    color: #444;
                    font-weight: 400;
                }
            }
            .qr-user {
                margin-top: 92px;
            }
            .h {
                margin-top: 0.48rem;
                font-size: 14px;
                color: #b3b3b3;
            }
        }
    }
    .avatar-wrapper {
        background: url("https://oss.tuoxingwang.com/vaporetto-assets/yyq/my/my-back.png")
            0 0 no-repeat;
        background-size: 100% 100%;
        height: 5.413333rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .avatar-container {
            border-radius: 50%;
            border: 0.053333rem solid rgba(255, 255, 255, 0.2);
            width: 1.706667rem;
            height: 1.706667rem;
            margin-bottom: 0.38rem;
            position: relative;
            flex: none;
            .avatar {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 50%;
            }
            .change-icon {
                width: 0.826667rem;
                height: 0.826667rem;
                position: absolute;
                right: -0.3rem;
                top: 0.9rem;
            }
        }
        .name {
            font-size: 18px;
            color: $black;
            @include multiple-text-overflow(3);
        }
    }
    .avatar-wrapper-tuo {
        background: url("https://oss.tuoxingwang.com/vaporetto-assets/user/png/avatar-wrapper-tuo.png")
            0 0 no-repeat;
        background-size: cover;
        height: 4.013333rem;
        display: flex;
        align-items: center;
        .avatar-container {
            margin-left: 0.6rem;
            margin-right: 0.6rem;
            border-radius: 50%;
            border: 0.053333rem solid rgba(255, 255, 255, 0.2);
            width: 1.973333rem;
            height: 1.973333rem;
            position: relative;
            flex: none;
            .avatar {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 50%;
            }
            .change-icon {
                width: 0.826667rem;
                height: 0.826667rem;
                position: absolute;
                right: -0.3rem;
                top: 0.9rem;
            }
        }
        .name-wrapper {
            // display: flex;
            .name {
                font-size: 16px;
                color: $white;
                font-weight: bold;
                @include multiple-text-overflow(3);
                margin-top: 0.08rem;
            }
        }
    }
    .nav {
        padding: 0.266667rem 0.4rem;
        display: flex;
        justify-content: space-between;
        background: $white;
        .each-nav {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
                width: 0.586667rem;
                height: 0.586667rem;
                margin-bottom: 0.266667rem;
            }
            span {
                color: #333;
                font-size: 14px;
            }
        }
    }
    .divider {
        height: 0.48rem;
        background: #f5f5f5;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
    }
    .list-wrapper {
        background: $white;
        border-radius: 0.266667rem 0.266667rem 0px 0px;
        overflow: hidden;
        position: relative;
        top: -20px;
        margin-bottom: 1.333333rem;
        &.normal {
            top: 0;
            border-radius: 0;
        }
        .each-list {
            padding: 0.426667rem 0.346667rem 0.426667rem 0;
            @include border1px(border-bottom, $grey3);
            margin-left: 0.533333rem;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.exit {
                justify-content: center;
            }
            .each-icon {
                position: absolute;
                left: 0;
                top: 0.45rem;
                width: 0.533333rem;
                height: 0.533333rem;
            }
            .right-icon {
                width: 0.306667rem;
                height: 0.426667rem;
            }
            span {
                color: #333;
                font-size: 14px;
                padding-left: 0.853333rem;
            }
            a {
                color: #333;
                font-size: 14px;
            }
            .exit {
                color: #444;
                padding-left: 0px;
            }
            .tel {
                color: #f0bb1b;
                font-size: 14px;
            }
        }
    }
    .list-wrapper-tuo {
        background: $white;
        border-radius: 0.266667rem 0.266667rem 0px 0px;
        overflow: hidden;
        position: relative;
        // top: -20px;
        margin-bottom: 1.333333rem;
        &.normal {
            top: 0;
            border-radius: 0;
        }
        .each-list {
            padding: 0.426667rem 0.346667rem 0.426667rem 0;
            @include border1px(border-bottom, $grey3);
            margin-left: 0.533333rem;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.exit {
                justify-content: center;
                border-bottom: 0;
            }
            .each-icon {
                position: absolute;
                left: 0;
                top: 0.45rem;
                width: 0.533333rem;
                height: 0.533333rem;
            }
            .right-icon {
                width: 0.306667rem;
                height: 0.426667rem;
            }
            span {
                color: #333;
                font-size: 14px;
                padding-left: 0.853333rem;
            }
            a {
                color: #333;
                font-size: 14px;
            }
            .exit {
                color: #444;
                padding-left: 0px;
            }
            .tel {
                color: #f0bb1b;
                font-size: 14px;
            }
        }
    }
    .yyq-user-wrapper {
        padding: 0.533333rem;
        display: flex;
        background: #fff;
        .left {
            margin-right: 0.32rem;
            width: 1.493333rem;
            height: 1.493333rem;
        }
        .right {
            flex: 1;
            .yyq_name {
                color: #444444;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 0.106667rem;
            }
            .yyq_account {
                color: #999999;
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .qr-line {
                    display: flex;
                    align-items: center;
                    .qr-icon {
                        width: 0.4rem;
                        height: 0.4rem;
                        margin-right: 0.24rem;
                    }
                    .right-icon {
                        width: 0.16rem;
                        height: 0.266667rem;
                    }
                }
            }
        }
    }

    .card-wrapper {
        margin-bottom: 10px;
        padding: 0 0.533333rem;
        background: #fff;
        .user-card {
            border-radius: 0.266667rem;
            overflow: hidden;
            background: url("https://oss.tuoxingwang.com/vaporetto-assets/yyq/my/my-back.png")
                center center no-repeat;
            background-size: cover;

            .b1 {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: $white;
                height: 3.04rem;
                .user-money {
                    font-size: 40px;
                    font-weight: bold;
                    .suffix {
                        font-size: 24px;
                        font-weight: bold;
                    }
                }
                .hint {
                    font-size: 16px;
                }
            }
            .b2 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 1.12rem;
                background: #acd944;
                color: $white;
                font-size: 16px;
                padding: 0 0.533333rem;
            }
        }
    }
    .empty {
        min-height: 1.3333333rem;
    }
}

.order-wrapper {
    padding: 0rem 0.56rem 0.533333rem;
    background: $white;
    .account-nav {
        width: 8.933333rem;
        height: 2.32rem;
        box-shadow: 0px 0px 0.16rem rgba(240, 187, 27, 0.2);
        border-radius: 0.266667rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        position: relative;
        background: $white;
        .each-nav-item {
            text-align: center;
            color: #4d4d4d;
            font-size: 0.32rem;
            display: flex;
            flex-direction: column;
            img {
                width: 0.613333rem;
                height: 0.64rem;
                margin: 0 auto;
                margin-bottom: 0.373333rem;
            }
        }
    }
}
.order-wrapper-tuo {
    padding: 0rem 0.56rem;
    // background: $white;
    position: relative;
    margin-top: -0.533333rem;
    margin-bottom: 0.293333rem;
    &.orderActive {
        margin-top: 0;
    }
    .account-nav {
        width: 8.933333rem;
        height: 2.32rem;
        box-shadow: 0px 4px 16px rgba(174, 174, 174, 0.25);
        border-radius: 0.266667rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        position: relative;
        background: $white;
        .each-nav-item {
            text-align: center;
            color: #4d4d4d;
            font-size: 0.32rem;
            display: flex;
            flex-direction: column;
            img {
                width: 0.613333rem;
                height: 0.64rem;
                margin: 0 auto;
                margin-bottom: 0.373333rem;
            }
        }
    }
}
</style>

